<template>
  <footer class="bloc-footer">
    <span class="text">© Krug 2023 - Please drink responsibly -</span>
    <a class="rgpd-link" onclick="Optanon.ToggleInfoDisplay()" href="javascript:void(0);">Cookies Settings</a>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
  .bloc-footer {
    width: 100vw;
    padding: 30px 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $th-white;
    color: $th-cherry;
    z-index: 10;
    flex-direction: column;

    @include media($from: small) {
      flex-direction: row;
    }

    .text {
      font-size: 16px;
    }

    .rgpd-link {
      color: $th-cherry;
      margin-top: 5px;

      @include media($from: small) {
        margin-left: 4px;
        margin-top: 0;
      }
    }
  }
</style>
